import {definePreset} from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

// console.log(JSON.stringify(Aura));
export const ThemePreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '3px',
            sm: '5px',
            md: '6px',
            lg: '8px',
            xl: '10px',
        },
    },
    semantic: {
        primary: {
            50: '{emerald.50}',
            100: '{emerald.100}',
            200: '{emerald.200}',
            300: '{emerald.300}',
            400: '{emerald.400}',
            500: '{emerald.500}',
            600: '{emerald.600}',
            700: '{emerald.700}',
            800: '{emerald.800}',
            900: '{emerald.900}',
            950: '{emerald.950}',
        },
        colorScheme: {
            light: {
                custom: {
                    tableHeaderColor: "#373737"
                },
            },
            dark: {
                custom: {
                    tableHeaderColor: "#a8a8a8"
                },
            }
        }
    },
    components: {
        button: {
            outlined: {
                danger: {
                    borderColor: '{red-500}'
                }
            }
        },
        card: {
            body: {
                padding: '0',
            }
        },
        datatable: {
            headerCell: {
                color: "{custom.tableHeaderColor}",
                padding: "0.35rem .6rem",
            },
            bodyCell: {
                padding: "0.35rem .6rem",
            }
        },
        fieldset: {
            legend: {
                background: 'transparent',
                padding: '0'
            }
        },
        menubar: {
            root: {
                borderColor: "transparent",
            }
        },
        tabs: {
            tablist: {
                background: 'transparent',
            },
            tab: {
                background: 'transparent',
            },
            tabpanel: {
                padding: '1rem 0 0 0 ',
                background: 'transparent',
            }
        },
        tieredmenu: {
            root: {
                borderColor: "transparent",
                transitionDuration: "0",
            }
        },
        togglebutton: {
            root: {
                sm: {
                    padding: "0",
                },
            },
            colorScheme: {
                dark: {
                    root: {
                        borderColor: "{surface.600}",
                        checkedBorderColor: "{surface.600}",
                    },
                },
                light: {
                    root: {
                        borderColor: "{surface.300}",
                        checkedBorderColor: "{surface.300}",
                    },
                },
            },
        },
        toggleswitch: {
        },
        toolbar: {
            root: {
                borderColor: "transparent",
            },
        },
    },

});
